import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createPartAddtoOrders,
  getPartAddtoOrdersById,
  updatePartAddtoOrders,
} from "./services/ghat.services";
import { clearPartAddtoOrdersDetail } from "./partAddtoOrdersSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { findAllActiveItem } from "../item/services/item.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import {
  clearFilterOrder,
  clearOrderDetail,
  setFilterOrder,
} from "../order/orderSlice";
import FormTextArea from "../../components/formFields/FormTextArea";
import { clearItemDetail } from "../item/itemSlice";
import { ErrorToast } from "../../components/toast/Toasts";
import { FaRegEye } from "react-icons/fa";
import { IProcess } from "../process/processModel";
import { findAllActiveProcess } from "../process/services/process.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { FetchWeight } from "../palish/services/palish.services";
import {
  findAllOrderLabelandPurchaseData,
  findAllOrder,
  findbyOrderNo,
} from "../order/services/order.services";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { CustomAppDialog } from "../../components/dialog/Dialog";
import { ImCross } from "react-icons/im";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import FormTextField from "../../components/formFields/FormTextField";
import PartAddtoOrdersRawItemArray from "./PartAddtoOrdersRawItemArray";
import PartAddtoOrdersOrderItemArray from "./PartAddtoOrdersOrderItemArray";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const TotalAmountWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const rawItems = formRenderProps.valueGetter("RAWITEM") || [];
  const orderItems = formRenderProps.valueGetter("ORDERITEM") || [];

  useEffect(() => {
    let totalAmount = 0;

    rawItems.forEach((item: any) => {
      totalAmount += item.Total || 0;
    });

    orderItems.forEach((item: any) => {
      totalAmount += item.Total || 0;
    });

    const currentTotal = formRenderProps.valueGetter("total_amount");
    if (currentTotal !== totalAmount) {
      formRenderProps.onChange("total_amount", { value: totalAmount });
    }
  }, [
    JSON.stringify(rawItems.map((item: any) => ({ Total: item.Total }))),
    JSON.stringify(orderItems.map((item: any) => ({ Total: item.Total }))),
  ]);

  return null;
};

const ProcessChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const process_id = formRenderProps.valueGetter("process_id");

  useEffect(() => {
    // You can add any process-specific logic here
    if (process_id) {
      console.log("Process changed:", process_id);
    }
  }, [process_id]);

  return null;
};

const CreatePartAddtoOrders: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const gridRef = useRef<any>(null);

  const PartAddtoOrderNo = location?.state?.PartAddtoOrderNo;
  const loading = useAppSelector((state) => state.partAddtoOrders?.loading);
  const orderLoading = useAppSelector((state) => state.order?.loading);
  const ProcessList = useAppSelector((state) => state.Process.ProcessList);
  const PartAddtoOrdersSave = useAppSelector(
    (state) => state.partAddtoOrders?.PartAddtoOrdersSave,
  );
  const PartAddtoOrdersDetail = useAppSelector(
    (state) => state.partAddtoOrders.PartAddtoOrdersDetail,
  );
  const FilterOrder = useAppSelector((state) => state.order.FilterOrder);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const [formKey, setFormKey] = useState(1);

  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;

  useEffect(() => {
    const payload = {
      ...FilterOrder,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(findAllOrder(payload));
    dispatch(findAllOrderLabelandPurchaseData(payload));
  }, []);

  useEffect(() => {
    dispatch(findAllActiveProcess());
    dispatch(findAllActiveItem());
    dispatch(findAllActiveItemCategory());
    return () => {
      dispatch(clearPartAddtoOrdersDetail());
      dispatch(clearOrderDetail());
      dispatch(clearItemDetail());
      dispatch(closeDialog());
    };
  }, []);

  useEffect(() => {
    if (PartAddtoOrderNo) {
      dispatch(getPartAddtoOrdersById(PartAddtoOrderNo));
      dispatch(closed());
    }
  }, [PartAddtoOrderNo]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [PartAddtoOrdersDetail]);

  const handleSubmit = async (values: any) => {
    if (PartAddtoOrdersSave) {
      return null;
    }

    if (!(values.RAWITEM?.length || values.ORDERITEM?.length)) {
      ErrorToast(
        "Either Raw Items or Order Items must be added before saving the record.",
      );
      return;
    }

    const formData = {
      Date: values.Date
        ? moment(values.Date).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        : moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      process_id: values.process_id ? +values.process_id : 0,
      OrderNo: values.OrderNo ? +values.OrderNo : 0,
      ProductName: values.ProductName || "",
      Weight: values.Weight ? +values.Weight : 0,
      Remarks: values.Remarks || "",
      IsActive: values.IsActive !== undefined ? values.IsActive : true,
      CreatedBy: values.CreatedBy || "user",
      UpdatedBy: values.UpdatedBy || "user",
      RAWITEM: values.RAWITEM
        ? values.RAWITEM.map((item: any) => ({
            ID: item.ID ? item.ID : 0,
            PartAddtoOrderNo: item.PartAddtoOrderNo ? item.PartAddtoOrderNo : 0,
            item_id: item.item_id ? +item.item_id : 0,
            GrossWeight: item.GrossWeight ? +item.GrossWeight : 0,
            NetWeight: item.NetWeight ? +item.NetWeight : 0,
            Rate: item.Rate ? +item.Rate : 0,
            Total: item.Total ? +item.Total : 0,
          }))
        : [],
      ORDERITEM: values.ORDERITEM
        ? values.ORDERITEM.map((item: any) => ({
            ID: item.ID ? item.ID : 0,
            PartAddtoOrderNo: item.PartAddtoOrderNo ? item.PartAddtoOrderNo : 0,
            item_id: item.item_id ? +item.item_id : 0,
            GrossWeight: item.GrossWeight ? +item.GrossWeight : 0,
            NetWeight: item.NetWeight ? +item.NetWeight : 0,
            Rate: item.Rate ? +item.Rate : 0,
            Total: item.Total ? +item.Total : 0,
          }))
        : [],
    };

    if (PartAddtoOrderNo) {
      const editPayload = {
        ID: PartAddtoOrderNo,
        ...formData,
      };
      try {
        const response = await dispatch(updatePartAddtoOrders(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/partaddtoorders");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createPartAddtoOrders(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/partaddtoorders");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  const handleFormClose = () => {
    navigate("/partaddtoorders");
  };

  const handleSelectOrder = () => {
    dispatch(openDialog("addpartorderselectiondialog"));
  };

  const handlefetchWeight = async (
    previous_process_id: number,
    order_id: number,
    formRenderProps: FormRenderProps,
  ) => {
    const payload = {
      process_id: previous_process_id,
      order_id: order_id,
    };
    const res = await dispatch(FetchWeight(payload));
    if (res.meta.requestStatus === "fulfilled") {
      formRenderProps.onChange(`Weight`, {
        value: res.payload.Data[0].gross_weight || 0,
      });
    }
  };

  return (
    <>
      {(loading || orderLoading) && <LoadingPanel gridRef={gridRef} />}

      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={PartAddtoOrdersDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ProcessChangeWatcher formRenderProps={formRenderProps} />
            <TotalAmountWatcher formRenderProps={formRenderProps} />
            <SelectOrderDialog
              formRenderProps={formRenderProps}
              handlefetchWeight={handlefetchWeight}
            />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "24%" },
                  { width: "24%" },
                  { width: "24%" },
                  { width: "24%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <Typography.h4>
                    {PartAddtoOrderNo
                      ? "Update Part Add to Order"
                      : "Create Part Add to Order"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={4}>
                  {PartAddtoOrderNo &&
                    PartAddtoOrdersDetail?.PartAddtoOrderNo && (
                      <Typography.h5>
                        No :{" "}
                        <span style={{ color: "green" }}>
                          {PartAddtoOrdersDetail.PartAddtoOrderNo}
                        </span>
                      </Typography.h5>
                    )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="Date"
                    label="Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    max={maxDate}
                    value={new Date()}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}> </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`process_id`}
                    label="Previous Process"
                    placeholder="Select Previous Process"
                    component={FormSelectionField}
                    onChange={(e) => {
                      const order_no = formRenderProps.valueGetter("order_no");
                      e?.value &&
                        order_no &&
                        handlefetchWeight(e.value, order_no, formRenderProps);
                    }}
                    options={ProcessList?.map((process: IProcess) => {
                      return {
                        value: process.ID,
                        label: process.process_name,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{ display: "flex", alignItems: "start", gap: 10 }}
                >
                  <Button
                    type="button"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    style={{
                      width: "fit-content",
                      padding: "5px",
                      marginTop: "40px",
                    }}
                    onClick={() => handleSelectOrder()}
                  >
                    Select Order
                  </Button>
                  {formRenderProps.valueGetter(`OrderNo`) !== null && (
                    <Field
                      name={`OrderNo`}
                      label="Order No"
                      placeholder="Order No"
                      disabled={"true"}
                      wrapperStyle={{ width: "50%" }}
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`ProductName`}
                    label="Product name"
                    placeholder="Select Product"
                    component={FormTextField}
                    validator={requiredValidator}
                    disabled
                    astrike={true}
                    // disabled={
                    //   !formRenderProps.valueGetter("order_no") ? false : true
                    // }
                    // options={
                    //   ItemList &&
                    //   filterItems(
                    //     formRenderProps.valueGetter(`item_category_id`),
                    //   )
                    // }
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="Weight"
                    label="Weight (gm)"
                    placeholder="0.000"
                    format="n3"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>

            {/* Raw Items Section */}
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              ></GridLayoutItem>
              <FieldArray
                formRenderProps={formRenderProps}
                component={PartAddtoOrdersRawItemArray}
                name="RAWITEM"
              />
            </ShadowCard>

            {/* Order Items Section */}
            <ShadowCard style={{ marginTop: 10 }}>
              <FieldArray
                formRenderProps={formRenderProps}
                component={PartAddtoOrdersOrderItemArray}
                name="ORDERITEM"
              />
            </ShadowCard>

            {/* Remarks Section */}
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem>
                  <Field
                    rows={2}
                    name="Remarks"
                    label="Remarks"
                    placeholder="Write Here..."
                    component={FormTextArea}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={2}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {/* {isPrintAccess && PartAddtoOrderNo && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(
                          `/partaddtoorders/${PartAddtoOrderNo}`,
                          "_blank",
                        )
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )} */}
                  <Button
                    type="button"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    style={{ marginRight: 4 }}
                    onClick={handleFormClose}
                  >
                    Go To Part Addto Orders List
                  </Button>
                  <ButtonWithLoading
                    label={!PartAddtoOrderNo ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreatePartAddtoOrders;

interface SelectDialogProps {
  formRenderProps: FormRenderProps;
  handlefetchWeight: (
    previous_process_id: number,
    order_id: number,
    formRenderProps: FormRenderProps,
  ) => void;
}

const SelectOrderDialog = ({
  formRenderProps,
  handlefetchWeight,
}: SelectDialogProps) => {
  const orderList = useAppSelector((state) => state.order.OrderList);

  const dispatch = useAppDispatch();

  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const loading = useAppSelector((state) => state.order.loading);
  const gridRef = useRef<any>(null);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyImageCommandCell = (props: GridCellProps) => {
    const handlClickItem = (image: string) => {
      if (image && typeof image === "string") {
        window.open(image);
      }
    };
    if (props.dataItem?.image === null) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
          <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
        </div>
      );
    }

    return (
      <td className="action-td main-image">
        <div
          style={{
            position: "relative",
            // border: "1px dotted lightgrey",
            // borderRadius: "5px",
            // height: "50px",
            // overflow: "hidden",
          }}
        >
          <Avatar
            className="select-order-avatar"
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: props.dataItem?.image_name
                ? "transparent"
                : "#303F9F",
            }}
          >
            {props.dataItem?.image_name ? (
              <img
                src={props.dataItem?.image_name}
                alt={`No Image`}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              `No Image`
            )}
          </Avatar>
          <div className="image-view">
            <FaRegEye
              style={{
                color: "white",
                height: 24,
                width: 24,
                cursor: "pointer",
              }}
              onClick={() => handlClickItem(props.dataItem?.image_name)}
            />
          </div>
        </div>
      </td>
    );
  };

  const MyEditCommandCell = (props: any) => {
    const handleSelectOrder = (order_no: number) => {
      formRenderProps.onChange(`OrderNo`, {
        value: order_no,
      });

      const hasPreviousProcessId = formRenderProps.valueGetter(`process_id`);

      const getOrderNowiseData = async () => {
        const updateField = (field: any, value: any) =>
          formRenderProps?.onChange(`${field}`, {
            value,
          });

        if (!order_no || formRenderProps.modified !== true) {
          updateField("item_category_id", null);
          updateField("item_id", null);
          updateField("ProductName", "");
          updateField("remarks", " ");
          updateField("purity_id", null);
          updateField("weight", "");
          updateField("OrderNo", null);
          updateField("Images", null);
          return;
        }

        try {
          const { payload: res, meta } = await dispatch(
            findbyOrderNo({ order_no, process_id: 0 }),
          );
          if (meta.requestStatus === "fulfilled" && res) {
            updateField("order_id", res?.id);
            updateField("item_category_id", res?.item_category_id);
            updateField("item_id", res?.item_id);
            updateField("OrderNo", res?.order_no);
            updateField("ProductName", res?.item_name);
            updateField("remarks", res?.description || " ");
            updateField("purity_id", res?.purity);
            updateField("Weight", res?.weight ? +res?.weight : "");
            updateField("Images", res?.Images ? +res?.Images : "");
            if (hasPreviousProcessId && res?.item_id) {
              handlefetchWeight(
                hasPreviousProcessId,
                order_no,
                formRenderProps,
              );
            }
          } else {
            updateField("item_category_id", null);
            updateField("item_id", null);
            updateField("ProductName", " ");
            updateField("remarks", " ");
            updateField("purity_id", null);
            updateField("Weight", "");
            updateField("order_no", null);
            updateField("OrderNo", null);
            updateField("order_id", null);
            updateField("Images", null);
          }
        } catch (error) {
          console.error(error);
        }
      };
      getOrderNowiseData();
      dispatch(closeDialog());
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() => handleSelectOrder(props.dataItem?.order_no)}
        >
          Select
        </Button>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 6 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const OrderFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.order.FilterOrder}
        setFilterAction={setFilterOrder}
        clearFilterAction={clearFilterOrder}
        fetchDataAction={findAllOrder}
        pagination={{ case: "lowercase" }}
      />
    ),
    [],
  );

  return (
    <>
      <CustomAppDialog open={dialogName === "addpartorderselectiondialog"}>
        <div style={{ width: "60vw", overflow: "hidden" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout
            // style={{
            //   marginLeft: 30,
            // }}
            gap={{ rows: 10, cols: 10 }}
          >
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4 style={{ margin: 0 }}>
                {"Select Order"}
              </Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => {
                  dispatch(closeDialog());
                  dispatch(clearFilterOrder());
                }}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "60vw" }}>
              <KendoGrid
                className="selection-dialog responsive-table"
                style={{ maxHeight: "calc(100vh - 152px)" }}
                filterable={true}
                filter={filter}
                data={filter ? filterBy(orderList, filter) : orderList}
                total={orderList[0]?.itemcount || orderList.length}
                onFilterChange={handleFilterChange}
                skip={currentPage * pageLimit}
                take={pageLimit}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [10, 50, 100, 300, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
              >
                <Column
                  field="image_name"
                  title="Image"
                  width={100}
                  cells={{
                    data: MyImageCommandCell,
                  }}
                  filterable={false}
                />
                <Column
                  field="order_no"
                  title="Order No"
                  width={100}
                  filterable={false}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div style={{ color: "green" }}>
                          <strong>
                            {props.dataItem?.order_no}
                            {props.dataItem?.ordersub_no
                              ? `.${props.dataItem?.ordersub_no}`
                              : ""}
                          </strong>
                        </div>
                      </td>
                    ),
                  }}
                />
                <Column
                  field="party_name"
                  title="Party Name"
                  width={200}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="item_name"
                  title="Product Name"
                  width={200}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="order_date"
                  title="Order Date"
                  width={130}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="delivery_date"
                  title="Delivery Date"
                  width={130}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="order_no"
                  title="Actions"
                  cells={{ data: MyEditCommandCell }}
                  width={90}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};
